﻿
import common from "../common";
import context_ from "./context";
import HotEditableFormManager_ from "./vue/hotEditable/HotEditableFormManager";
declare function require(module: string): unknown;
const context = require("./context") as typeof context_;

/** Tools de debuggage pour faire des tests dans la console du navigateuret valider la structure des WebComponents affichés */
class Debug {
    getDefaultSearchedItems(): common.IEmbeddedComponentToUpdate[] {
        return [
            { name: 'FermeEditFluxDeTravauxForm' },
            { name: 'FermeEditIdentificationForm' },
            { name: 'FermeEditAssociationsForm' },
            { name: 'FermeEditCaracteristiquesForm' },
            { name: 'FermeEditFermesLieesForm' },
            { name: 'FermeEditPersonnesForm' },
            { name: 'FermeEditProduitsAgricolesForm' },
            { name: 'FermeEditPotentielAgricoleForm' },
            { name: 'FermeEditCotisationsForm' },
            { name: 'FermeEditDeclarationsForm' },
            { name: 'FermeEditAdhesionsForm' },
            { name: 'FermeEditMapaqForm' },
            { name: 'FermeEditLiaisonForm' },
            { name: 'FermeEditTacheAdministrativeForm' },
            { name: null },
            { name: null },
            { name: 'FermeEditPersonnesForm' },
            { name: 'FermeEditPersonnesForm' },
            { name: 'FermePersonneForm_6128f15e4eec4b0f889b9166f9890702' },
            { name: 'FermePersonneForm_INEXISTANT' }
        ];
    }

    testUpdateEmbeddedContents(source?: number, searched?: common.IEmbeddedComponentToUpdate[]) {
        console.log('\r\n\r\n\r\n\r\n=====================================================================================================\r\n============================================ TEST/UPDATE ============================================');

        console.log("> tree nodes before: ");
        this.drawTreeNodes();   

        console.log("> top level web components: ");
        const components = (context.components.items.DefaultEdit[0]._editVue.formManager as HotEditableFormManager_).getHotEmbeddedComponents();
        components.forEach(x => console.log("{name: '" + x.elementName + "'},"));

        const s1 = context.components.items.DefaultEdit[0]._editVue.formManager;
        const s2 = context.components.items.DefaultEdit[0]._editVue.formManager.formNode._childrenNodes[0]._formManager;
        const test = {
            source: source === 2 ? s2 : s1,
            searched: searched ?? this.getDefaultSearchedItems()
        }
        const f = function () {
            if (test.source) {
                const caller = test.source.formNode?._containerFieldName;
                console.log('> source : ' + (caller ?? 'TOP_PARENT') + ', alsoUpdateCurrent: ' + (test.source as HotEditableFormManager_).updateHotEmbeddedComponents(test.searched, caller));
            } else {
                console.log("> aucun 'webComponent.editVue'");
            }
        }
        setTimeout(f, 1);
        console.log("> test in progress...");
        "  (after this test, run main.debug.drawTreeNodes() to validate the structure of the WebComponents)";
    }

    drawTreeNodes() {
        return context.components.getPage().drawTreeNodes();
    }
}
export = new Debug();